// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/entry_point.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveEntryPointRequest, ArchiveEntryPointResponse, BindCampaignRequest, BindCampaignResponse, CreateEntryPointRequest, CreateEntryPointResponse, GetEntryPointRequest, GetEntryPointResponse, ListCampaignEntriesRequest, ListCampaignEntriesResponse, ListEntryPointsRequest, ListEntryPointsResponse, UnbindCampaignRequest, UnbindCampaignResponse, UpdateEntryPointRequest, UpdateEntryPointResponse } from "./entry_point_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * EntryPointService: one path of a tracking domain shared by many campaigns
 * (docs/specs/use-cases/entry-point.md). Every campaign behind it has the same
 * ad link but its own token — https://<domain>/?<token> — and the token picks
 * the campaign at the edge. A visit without a known token goes by the rules
 * (field conditions → campaign), then the visitor's sticky cookie, then the
 * fallback. A change reaches the edge with the domain's next publication
 * (about a minute).
 *
 * @generated from service tracker.v1.EntryPointService
 */
export const EntryPointService = {
  typeName: "tracker.v1.EntryPointService",
  methods: {
    /**
     * @generated from rpc tracker.v1.EntryPointService.ListEntryPoints
     */
    listEntryPoints: {
      name: "ListEntryPoints",
      I: ListEntryPointsRequest,
      O: ListEntryPointsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.EntryPointService.GetEntryPoint
     */
    getEntryPoint: {
      name: "GetEntryPoint",
      I: GetEntryPointRequest,
      O: GetEntryPointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.EntryPointService.CreateEntryPoint
     */
    createEntryPoint: {
      name: "CreateEntryPoint",
      I: CreateEntryPointRequest,
      O: CreateEntryPointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.EntryPointService.UpdateEntryPoint
     */
    updateEntryPoint: {
      name: "UpdateEntryPoint",
      I: UpdateEntryPointRequest,
      O: UpdateEntryPointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.EntryPointService.ArchiveEntryPoint
     */
    archiveEntryPoint: {
      name: "ArchiveEntryPoint",
      I: ArchiveEntryPointRequest,
      O: ArchiveEntryPointResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Puts a campaign of the entry point's domain behind it; a second call
     * changes its token. Empty token = a new random UUID.
     *
     * @generated from rpc tracker.v1.EntryPointService.BindCampaign
     */
    bindCampaign: {
      name: "BindCampaign",
      I: BindCampaignRequest,
      O: BindCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.EntryPointService.UnbindCampaign
     */
    unbindCampaign: {
      name: "UnbindCampaign",
      I: UnbindCampaignRequest,
      O: UnbindCampaignResponse,
      kind: MethodKind.Unary,
    },
    /**
     * The entry points a campaign sits behind, with its token and ad link.
     *
     * @generated from rpc tracker.v1.EntryPointService.ListCampaignEntries
     */
    listCampaignEntries: {
      name: "ListCampaignEntries",
      I: ListCampaignEntriesRequest,
      O: ListCampaignEntriesResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

